import {
  FontSizes,
  NeutralColors,
  Panel,
  PanelType,
  TextField,
} from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";
import { MensajeBar } from "../../../components/generic/ManejoResponseMessage/MessageBar";
import IdicadorProgress from "../../../components/generic/IndicadorProgress";
import { PanelFooterGestionDocumentos } from "../general/PanelFooterGestionDocumentos";
import { _helperIBaseResponse } from "../../../Interfaces/gestionDocumentos/ITipoDocumento";
import grupoDocumentoService from "../../../services/gestionDocumentos/grupoDocumentoService";

interface IPanelRegistrarSubGrupo {
  isOpen: boolean;
  onDismiss: () => void;
  onRenderTable: () => void;
  parentId: string;
}

export const PanelRegistrarSubGrupo = (props: IPanelRegistrarSubGrupo) => {
  const [isSend, setIsSend] = useState(false);
  const [isSaccesfull, setIsSaccesfull] = useState(false);
  const [isError, setIsError] = useState(false);
  const [mensajeError, setMensajeError] = useState("");
  const [mensaje, setMensaje] = useState("");

  const [isContenedor, setIsContenedor] = useState(false);
  const [disableForm, setDisableForm] = useState(true);

  const [nombreTipo, setNombreTipo] = useState("");

  useEffect(() => {
    if (props.isOpen) {
      setIsSend(false);
      setIsSaccesfull(false);
      validarForm();
    }
  }, [props.isOpen]);

  useEffect(() => {
    validarForm();
  }, [nombreTipo]);

  const validarForm = () => {
    if (nombreTipo == null) setDisableForm(true);
    if (nombreTipo !== null) {
      if (nombreTipo) {
        setDisableForm(false);
      } else {
        setDisableForm(true);
      }
    }
  };

  const onRenderHeader = useCallback(
    () => (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "0px 24px",
            width: "100%",
          }}
        >
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size20,
            }}
          >
            Crear Nuevo SubGrupo
          </div>
          <div
            style={{
              color: NeutralColors.gray130,
              fontSize: FontSizes.size12,
            }}
          ></div>
        </div>
      </>
    ),
    []
  );

  const _confirmar = () => {
    if (props.parentId) {
      setIsSend(true);
      setDisableForm(true);
      setIsContenedor(true);
      grupoDocumentoService
        .crearGrupoDocumento({
          nombre: nombreTipo,
          archivoParentId: props.parentId,
        })
        .then((res) => {
          if (res.status === 200) {
            setIsSend(false);

            if (res.data.confirmacion) {
              setIsSaccesfull(true);
              setMensaje(res.data.mensaje);
              props.onRenderTable();
              setNombreTipo("");
              //Clone Panel after one second
              setTimeout(() => {
                _goback();
              }, 1000);
            } else {
              setIsError(true);
              setMensajeError(res.data.mensaje);
            }
          }
        })
        .catch((err: Error) => {
          setIsSend(false);
          setIsError(true);
          setMensajeError("No se puedo Registrar el SubGrupo");
        });
    }
  };

  const onRenderFooter = useCallback(
    () => (
      <>
        <PanelFooterGestionDocumentos
          texto="Crear"
          texto2={"Cancelar"}
          onClick={() => {
            _confirmar();
          }}
          onDismiss={() => {
            _goback();
          }}
          disableButton={disableForm}
        />
      </>
    ),
    [props.onDismiss, validarForm, _confirmar]
  );

  const onChange = (e: any, data: string | undefined) => {
    if (data != undefined) {
      setNombreTipo(data);
    }
  };

  const limpiarResponse = () => {
    setIsSend(false);
    // setIsContenedor(true);
    setIsSaccesfull(false);
    setNombreTipo("");
    setIsError(false);
    setMensajeError("");
    setMensaje("");
    props.onDismiss();
  };

  const _goback = () => {
    limpiarResponse();
    setIsContenedor(false);
  };

  return (
    <Panel
      isOpen={props.isOpen}
      onDismiss={_goback}
      onRenderHeader={onRenderHeader}
      onRenderFooter={onRenderFooter}
      type={PanelType.custom}
      customWidth="400px"
      isFooterAtBottom={true}
      isLightDismiss={true}
    >
      <>
        <br />
        {isSend && (
          <IdicadorProgress subText="Registrando Datos" isSend={isSend} />
        )}

        {isSaccesfull == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{
              mensaje: mensaje,
              codigoMensaje: 1,
            }}
          />
        )}

        {isError == true && (
          <MensajeBar
            ocultar={() => limpiarResponse()}
            response={{ mensaje: mensajeError, codigoMensaje: 3 }}
          />
        )}
        {/* <pre>{JSON.stringify(props.parentId, null, 2)}</pre> */}

        <div hidden={isContenedor}>
          <TextField
            onChange={onChange}
            value={nombreTipo}
            label="Nombre"
            required
            placeholder="Ingrese el nombre"
          />
        </div>
      </>
    </Panel>
  );
};
